"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const useScrollTrigger_1 = __importDefault(require("@mui/material/useScrollTrigger"));
const Slide_1 = __importDefault(require("@mui/material/Slide"));
function default_1(props) {
    const { window, disabled, children } = props;
    const trigger = disabled
        ? false
        : (0, useScrollTrigger_1.default)({
            target: window ? window() : undefined,
            threshold: 31, // ? my new Korean age
        });
    return ((0, jsx_runtime_1.jsx)(Slide_1.default, Object.assign({ appear: false, direction: "down", in: !trigger }, { children: children })));
}
exports.default = default_1;
